import { render } from "./Cabecalho.vue?vue&type=template&id=0d2557f9"
import script from "./Cabecalho.vue?vue&type=script&lang=js"
export * from "./Cabecalho.vue?vue&type=script&lang=js"

import "./Cabecalho.vue?vue&type=style&index=0&id=0d2557f9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__